/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import { LayoutWithStepper } from 'layouts';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';
// import { Link } from 'react-router-dom';
import selectors from 'shared/store/selectors';
import {
  stepAction, applicantAction, agreementAction,
} from 'shared/store/actions';

import {
  APPLICANT_HISTORY_CODE, PATH, CLIENT_CLASSIFICATION, QUALIFIED_TYPE_OF_INVESTMENT,
} from 'shared/constant';
import { FooterAction, Notes, PageContentWrapper } from 'components';

import './Checklist.scss';
import PdfIcon from 'assets/icons/icon-pdf-on.png';
import {
  isMobileOnly,
} from 'react-device-detect';

class Checklist extends Component {
  state = {
    sentStatus: this.props.intl.formatMessage({ id: 'sendEmailAgain' }),
    isPdfWithSignature: false,
    // isReloading: false,
  }

  async componentDidMount() {
    const {
      onUpdateCurrentStep,
      // intl, onUpdateSteps,
      onRefreshAllUrls, pdfRefreshed, onUpdateHistory, onStartCheckListPage,
      crmUrl, fatcaUrl, crsUrl, ndpfUrl, dpfUrl, cpfUrl, mftUrl,
      // onLoadSubcription, isShowSubcription,
    } = this.props;
    onUpdateHistory(APPLICANT_HISTORY_CODE.VIEW_AGREEMENT.code, APPLICANT_HISTORY_CODE.VIEW_AGREEMENT.codeI18n);
    onUpdateCurrentStep('step6');
    // onUpdateSteps(intl);
    // temporarily clear all url so that we can reload the document with signature when we reach CheckList
    if (!pdfRefreshed) {
      onRefreshAllUrls();
    }

    /** load if there is mutual fund subscription */
    // if (isShowSubcription) onLoadSubcription();

    // await onGetApplicantPdf(true);
    // await onGetCrsPDF();
    // await onGetFatcaPDF();
    onStartCheckListPage();

    if (crmUrl && fatcaUrl && crsUrl && ndpfUrl && dpfUrl && cpfUrl && mftUrl) this.setState({ isPdfWithSignature: true });
  }


 componentDidUpdate = (prevProps, prevStates) => {
   const {
     // intl, onUpdateSteps,
     onGetApplicantPdf,
     onGetFatcaPDF, onGetCrsPDF, onGetNdpfPDF,
     crmUrl, fatcaUrl, crsUrl, ndpfUrl, pdfGenerated,
     onGetDPFContract, dpfUrl, cpfUrl, onGetCpfPDF, mftUrl, onLoadSubcription, isShowSubcription,
   } = this.props;
   //  console.log('prevStates.isPdfWithSignature', prevStates, prevStates.isPdfWithSignature, this.state.isPdfWithSignature);
   if ((prevProps.pdfGenerated !== pdfGenerated && !pdfGenerated) || (prevStates.isPdfWithSignature === this.state.isPdfWithSignature && !this.state.isPdfWithSignature)) {
     setTimeout(() => {
       if (!crmUrl) {
         onGetApplicantPdf(true);
       }
     }, 10000);

     setTimeout(() => {
       if (!crsUrl) {
         onGetCrsPDF();
       }
     }, 10000);

     setTimeout(() => {
       if (!fatcaUrl) {
         onGetFatcaPDF();
       }
     }, 10000);


     setTimeout(() => {
       if (!ndpfUrl) onGetNdpfPDF();
       if (!dpfUrl) onGetDPFContract();
       if (!cpfUrl) onGetCpfPDF();
       if (!mftUrl && isShowSubcription) onLoadSubcription();
     }, 30000);
   }
 }


  onFinish = () => {
    const {
      // onSendEmail, isEmailSent,
      history,
    } = this.props;
    // if (!isEmailSent) onSendEmail();
    history.push(PATH.CONFIRMATION);
  }

  onSendEmailAgain = () => {
    this.props.onSendEmail();
    this.setState({ sentStatus: this.props.intl.formatMessage({ id: 'emailSent' }) });
  }

  // onReloadPDF = async () => {
  //   const {
  //     onGetApplicantPdf, onGetFatcaPDF, onGetCrsPDF, onGetNdpfPDF,
  //   } = this.props;

  //   this.setState({ isReloading: true });
  //   Promise.all([
  //     await onGetApplicantPdf(),
  //     await onGetFatcaPDF(),
  //     await onGetCrsPDF(),
  //     await onGetNdpfPDF(),
  //   ]).then(() => this.setState({ isReloading: false }));
  // }

  render() {
    const {
      intl: { formatMessage }, emailAddress, isEmailSent,
      crmUrl, crsUrl, fatcaUrl, ndpfUrl,
      dpfUrl, clientClassification, typeOfInvestment, cpfUrl,
      isShowSubcription, mftUrl,
    } = this.props;
    const isQualifiedClient = clientClassification === CLIENT_CLASSIFICATION.QUALIFIED;
    const isDiscretionary = typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY;
    const isCustody = typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.CUSTODY;

    const footer = (
      <FooterAction
        isSingleButton={!isEmailSent}
        leftButton={this.state.sentStatus}
        onLeftButtonClick={() => this.onSendEmailAgain()}
        rightButton={formatMessage({ id: 'finish' })}
        onRightButtonClick={() => this.onFinish()}
      />
    );

    return (
      <>
        <PageContentWrapper isWithPadding isWithHeader>
          <div className="content-container content-container--withPadding">

            <p className="content-container__para">{formatMessage({ id: 'checklist.intro' }, { email: emailAddress })}</p>
            <section className="content-container__section">
              <ul className="checklist">
                <li>
                  {/* Client Relationship Management Form */}
                  {`${formatMessage({ id: 'crmForm' })}, ${formatMessage({ id: 'withTC' })}`}
                  {crmUrl
                    ? (<a href={crmUrl} target="_blank"><img src={PdfIcon} alt="file" /></a>) : (
                      <ReactLoading height="32px" width="32px" color="#e48196" type="spin" />

                    )}
                </li>
                <li>
                  <FormattedMessage id="crsForm" />
                  {crsUrl
                    ? (<a href={crsUrl} target="_blank"><img src={PdfIcon} alt="file" /></a>) : (
                      <ReactLoading height="32px" width="32px" color="#e48196" type="spin" />

                    )}
                </li>
                <li>
                  <FormattedMessage id="fatcaForm" />
                  {fatcaUrl
                    ? (<a href={fatcaUrl} target="_blank"><img src={PdfIcon} alt="file" /></a>) : (
                      <ReactLoading height="32px" width="32px" color="#e48196" type="spin" />

                    )}
                </li>
                {isShowSubcription ? (
                  <li>
                    <FormattedMessage id="mutualFundSubscriptionForm" />
                    {mftUrl
                      ? <a href={mftUrl} target="_blank"><img src={PdfIcon} alt="file" /></a>
                      : <ReactLoading height="32px" width="32px" color="#e48196" type="spin" />
                    }
                  </li>
                ) : (
                  <li>
                    Investment Agreements and Appendices
                    {ndpfUrl || dpfUrl || cpfUrl
                      ? (<a href={isQualifiedClient && isDiscretionary ? dpfUrl : isCustody ? cpfUrl : ndpfUrl} target="_blank"><img src={PdfIcon} alt="file" /></a>
                      ) : (
                        <ReactLoading height="32px" width="32px" color="#e48196" type="spin" />
                      )}
                  </li>
                )}
                {/* <li>Terms  & Conditions</li> */}
                {/* <li>Portfolio Agreement</li> */}
                {/* <li>Subscription Form</li> */}
              </ul>
            </section>

            <Notes
            // isInfo={false}
              msg={(
                <section className="checklist-notes">
                  <FormattedMessage id="checklist.reload.intro" />
                  {/* <Button
                  isPrimary
                  // isOutlineButton
                  isSmall
                  value={isReloading ? <ReactLoading height="18px" width="18px" color="#ffffff" type="spin" /> : <FormattedMessage id="checklist.reload" />}
                  onButtonClick={this.onReloadPDF}
                /> */}
                </section>
            )}
            />

            {/* <p className="content-container__para">{formatMessage({ id: 'checklist.bankInstruction' })}</p>
          <section className="content-container__section">
            <p>For fund contribution to your portfolio please follow the instructions below.</p>
            <p>Please transfer as per details given </p>

            <table border="0" cellSpacing="0" cellPadding="10">
              <thead>
                <tr>
                  <th>INTERNATIONAL INVESTMENT CLIENTS - IID - Account details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <small>Correspondent Bank</small>
                    <span>Deutsche Bank Trust Company Americas, New York</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <small>SWIFT CODE</small>
                    <span>BKTRUS33</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <small>Beneficiary  Bank</small>
                    <span>National Bank of Kuwait, Kuwait</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <small>SWIFT CODE</small>
                    <span>NBOKKWKW</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <small>IBAN</small>
                    <span>KW26NBOK0000000000002019884725</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <small>Beneficiary</small>
                    <span>KFC (Markaz) Clients - IID - Fiduciary Money</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </section> */}
            <span>-</span>
          </div>
          {!isMobileOnly && footer}
        </PageContentWrapper>
        {isMobileOnly && footer}

      </>
    );
  }
}

const mapStateToProps = state => ({
  crmUrl: state.applicantRootReducer.applicantReducer.crmUrl,
  pdfGenerated: state.applicantRootReducer.applicantReducer.pdfGenerated,
  fatcaUrl: state.applicantRootReducer.applicantReducer.fatcaUrl,
  crsUrl: state.applicantRootReducer.applicantReducer.crsUrl,
  ndpfUrl: state.applicantRootReducer.applicantReducer.ndpfUrl,
  mftUrl: state.applicantRootReducer.applicantReducer.mftUrl,
  pdfRefreshed: state.applicantRootReducer.applicantReducer.pdfRefreshed,
  emailAddress: selectors.getEmailAddress(state),
  isEmailSent: selectors.getApplicantIsEmailSent(state),

  clientClassification: selectors.getClientClassification(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
  dpfUrl: selectors.getDpfUrl(state),
  cpfUrl: selectors.getCpfUrl(state),

  isShowSubcription: selectors.isShowSubcription(state),
});

const mapDispatchToProps = dispatch => ({
  onGetApplicantPdf: isGetAll => dispatch(applicantAction.getApplicantPdf(isGetAll)),
  onGetFatcaPDF: () => dispatch(applicantAction.getFatcaPdf()),
  onGetCrsPDF: () => dispatch(applicantAction.getCrsPdf()),
  onGetNdpfPDF: () => dispatch(applicantAction.getNdpfPdf()),
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onSendEmail: () => dispatch(applicantAction.sendApplicationToEmail()),
  onRefreshAllUrls: () => dispatch(applicantAction.refreshAllUrls()),
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
  onStartCheckListPage: () => dispatch(applicantAction.checkIfPDFisGenerated()),
  onGetDPFContract: () => dispatch(agreementAction.generateDPFContract()),
  onGetCpfPDF: () => dispatch(agreementAction.generateCustodyContract()),
  onLoadSubcription: () => dispatch(agreementAction.loadSubcription()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(Checklist)));
